<template>
  <div class="flex flex-col justify-center items-start px-[16px] pt-[24px] md:p-0 md:mt-[60px] max-w-[450px] mx-auto">
    <h1 class="text-[#003F82] mt-[82px] [text-left text-[24px] leading-[28px] font-bold">
      To safely issue your prescription, you’ll need to complete a 6 month treatment review
    </h1>
    <div class="mt-[4px] text-[16px] text-left w-full">
      Please note if we don’t hear back from you within 3 months, we will pause treatment
    </div>

    <button class="mt-[24px] h-[70px] text-[18px] font-medium w-full md:w-[414px] primary-btn" v-on:click="start()">
      <div class="flex justify-center items-center">
        <span>Complete check in</span>
        <amp-img class="share-icons" src="/resources/img/icons/white_right_arrow.svg" alt="" width="26" height="16" />
      </div>
    </button>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    start: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },
});
</script>

<style scoped>
@tailwind utilities;
@tailwind components;
</style>
